import R from 'ramda'

export const isValidBasicStringOfLengthN = R.curry((length: number, basicString: string): boolean | string =>
  basicString.length >= length ? true : `The string has to be at least ${length} characters.`,
)
